module.exports = __webpack_public_path__ + "media/branding/Cloud_Agent_Suite_horizontal_blue-24ec4a51.svg";